import { Component, input } from "@angular/core";

@Component({
  selector: "common-spinner",
  standalone: true,
  imports: [],
  templateUrl: "./spinner.component.html",
  styleUrl: "./spinner.component.scss",
})
export class SpinnerComponent {
  readonly text = input("");
}
